import { collection, doc, DocumentReference, query, Timestamp, where } from "firebase/firestore";
import { useMemo } from "react";
import { useCollectionData, useDocumentData } from "react-firebase-hooks/firestore";
import { db } from "../firebase";

export type Viewer = {
  uid: string;
  nickname?: string;
};

export type View = {
  viewer: Viewer;
  date: Timestamp;

  // used for track downloads; tells which pack the download happened from
  packId?: string;
};
export type AggregatedViews = {
  viewers: Viewer[];
  last_dates: { [uid: string]: Timestamp };
};
export function useObjectViews(objRef: DocumentReference, objectType: "pack" | "track", onlyViewsInPackId?: string) {
  const aggregatedViewsRef = useMemo(
    () => objRef && doc(db, `${objRef.path}/${objectType === "pack" ? "views" : "downloads"}/aggregated`),
    [objRef, objectType]
  );

  //@ts-ignore
  const [views, loading, error, snapshot] = useDocumentData<AggregatedViews>(aggregatedViewsRef, {});

  const [viewsInPack, viewsInPackLoading, viewsInPackError, viewsInPackSnapshot] = useCollectionData<View>(
    // @ts-ignore
    objRef &&
      query(
        collection(db, `${objRef.path}/${objectType === "pack" ? "views" : "downloads"}`),
        where("packId", "==", onlyViewsInPackId || "")
      ),
    {}
  );

  const viewsInPackAggregated = useMemo(() => {
    if (viewsInPackLoading || viewsInPackError || !viewsInPack) return null;
    console.log("viewsInPack", viewsInPack);
    return viewsInPack.reduce(
      (acc, view) => {
        if (acc.viewers.find((av) => av.uid === view.viewer.uid)) return acc;

        // encountered view from new viewer; add to viewer array
        acc.viewers.push(view.viewer);

        // update last date for viewer if it's newer
        if (!acc.last_dates[view.viewer.uid] || view.date > acc.last_dates[view.viewer.uid]) {
          acc.last_dates[view.viewer.uid] = view.date;
        }
        return acc;
      },
      { viewers: [], last_dates: {} }
    );
  }, [viewsInPackLoading, viewsInPackError, viewsInPack]);

  const processedViews = useMemo(() => {
    if (loading) return null;
    if (!views) return { viewers: [], last_dates: {} };

    return views;
  }, [views, loading]);

  return { loading, views: processedViews, viewsInPack, viewsInPackAggregated };
}
